module.exports = __webpack_public_path__ + "static/media/pro-info-sharing-bg.4d021ee0.png";